import { useMutation } from '@apollo/client'
import {  
  GenerateNewInvoiceVariables,
  GenerateNewInvoice
} from '../../types'
import { GENERATE_NEWINVOICE } from './operations'

export const useGenerateNewInvoice = () => useMutation<
  GenerateNewInvoice,
  GenerateNewInvoiceVariables
>(GENERATE_NEWINVOICE)
